// Draggable logic taken from this Svelte REPLL: https://svelte.dev/repl/75d34e46cbe64bb68b7c2ac2c61931ce?version=3.34.0
import { throttle } from 'lodash';

// eslint ignore
export default function draggable(node) {
  let x;
  let y;
  let throttledMouseMoveFunction;
  function handleMousemove(event) {
    if (event.type === 'touchmove') {
      // eslint-disable-next-line
      event = event.changedTouches[0];
    }
    const dx = event.clientX - x;
    const dy = event.clientY - y;
    x = event.clientX;
    y = event.clientY;

    node.dispatchEvent(
      new CustomEvent('dragmove', {
        detail: {
          x,
          y,
          dx,
          dy,
        },
      })
    );
  }
  function handleMousedown(event) {
    if (event.type === 'touchstart') {
      // eslint-disable-next-line
      event = event.touches[0];
    }

    x = event.clientX;
    y = event.clientY;

    node.dispatchEvent(
      new CustomEvent('dragstart', {
        detail: { x, y },
      })
    );

    throttledMouseMoveFunction = throttle(handleMousemove, 50);

    // eslint-disable-next-line
    window.addEventListener('mousemove', throttledMouseMoveFunction);
    // eslint-disable-next-line
    window.addEventListener('mouseup', handleMouseup);
    // eslint-disable-next-line
    window.addEventListener('touchmove', throttledMouseMoveFunction);
    // eslint-disable-next-line
    window.addEventListener('touchend', handleMouseup);
  }
  function handleMouseup(event) {
    x = event.clientX;
    y = event.clientY;

    node.dispatchEvent(
      new CustomEvent('dragend', {
        detail: { x, y },
      })
    );

    window.removeEventListener('mousemove', throttledMouseMoveFunction);
    window.removeEventListener('mouseup', handleMouseup);
    window.removeEventListener('touchmove', throttledMouseMoveFunction);
    window.removeEventListener('touchend', handleMouseup);
  }
  node.addEventListener('mousedown', handleMousedown);
  node.addEventListener('touchstart', handleMousedown, { passive: true });
  return {
    destroy() {
      node.removeEventListener('mousedown', handleMousedown);
      node.removeEventListener('touchstart', handleMousedown, {
        passive: true,
      });
    },
  };
}
